import { Navigate } from "react-router-dom";
import decryptCookieData from "./Functions/decryptCookieData";

function PrivateRoute({ children }) {
    const userData = JSON.parse(localStorage.getItem("2xgxgshdugyywerw12gh")) || "";
    console.log(userData)
    const userMain = userData 
    return userMain ? children : <Navigate to="/login" />;

}

export default PrivateRoute;